<template>
  <div>
    <AdminAppBar />

    <v-container fluid class="text-center details">
      <v-row justify="center" align="center">
        <div>
          <Booking :currentDay="currentDay" v-if="currentDay.slots" />
          <br />
          <v-btn color="primary black--text" :to="{ name: 'admin' }">Back to Admin</v-btn>
        </div>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { db } from "../firebase/firebase";
import UtilsMixin from "../mixins/UtilsMixin";
import Booking from "../components/Booking";
import AdminAppBar from "../components/core/AdminAppBar";

export default {
  data: () => ({
    currentDay: {},
    userData: {},
    bookedDays: [],
    active: null,
  }),
  components: {
    Booking,
    AdminAppBar,
  },
  mixins: [UtilsMixin],
  firestore() {
    return {
      calEvent: db.collection("calEvent"),
    };
  },
  methods: {
    setActive(value) {
      this.active = value;
    },
    updateUser(user) {
      this.$firestore.users.doc(user).set({
        name: this.currentUser.name,
        email: this.currentUser.email,
        workout: this.currentUser.workout,
      });
    },
    deleteWorkout(user) {
      this.$firestore.users.doc(user[".key"]).delete();
    },
  },
  created() {
    this.$firestore.calEvent
      .doc(this.$route.params.calEventId)
      .get()
      .then((doc) => {
        this.currentDay = doc.data();
      });
  },
};
</script>
<style lang="scss" scoped>
.details {
  min-width: 400px;
}
</style>
